import React from 'react';
import { createContainer } from 'unstated-next';
import { FormSchemaEntry } from './types';

export interface GIKFormState {
  schema?: FormSchemaEntry[];
  vertical?: boolean;
}

function useFormContext(state: GIKFormState): GIKFormState {
  const [schema] = React.useState(state.schema);
  const [vertical] = React.useState(state.vertical);
  return { schema, vertical };
}

export const FormContext = createContainer(useFormContext);
